import { render, staticRenderFns } from "./AudioCollections.vue?vue&type=template&id=c86ed122&scoped=true"
import script from "./AudioCollections.vue?vue&type=script&lang=js"
export * from "./AudioCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86ed122",
  null
  
)

export default component.exports